import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export const PrivacyPolicyPage = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-4798">
      <Navbar scrolled={scrolled} data-id="element-4799" />
      <main className="pt-24 pb-20" data-id="element-4800">
        <div className="container mx-auto px-4 md:px-6" data-id="element-4801">
          <div className="max-w-6xl mx-auto" data-id="element-4802">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-4803">
              Privacy Policy
            </h1>
            <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-4804">
              Learn about how we collect, use, and protect your data.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-4805" />
    </div>;
};